"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = void 0;

var isGlob = require("is-glob");

var _ = require("lodash");

var micromatch = require("micromatch");

var url = require("url");

var errors_1 = require("./errors");

function match(context, uri, req) {
  // single path
  if (isStringPath(context)) {
    return matchSingleStringPath(context, uri);
  } // single glob path


  if (isGlobPath(context)) {
    return matchSingleGlobPath(context, uri);
  } // multi path


  if (Array.isArray(context)) {
    if (context.every(isStringPath)) {
      return matchMultiPath(context, uri);
    }

    if (context.every(isGlobPath)) {
      return matchMultiGlobPath(context, uri);
    }

    throw new Error(errors_1.ERRORS.ERR_CONTEXT_MATCHER_INVALID_ARRAY);
  } // custom matching


  if (_.isFunction(context)) {
    var pathname = getUrlPathName(uri);
    return context(pathname, req);
  }

  throw new Error(errors_1.ERRORS.ERR_CONTEXT_MATCHER_GENERIC);
}

exports.match = match;
/**
 * @param  {String} context '/api'
 * @param  {String} uri     'http://example.org/api/b/c/d.html'
 * @return {Boolean}
 */

function matchSingleStringPath(context, uri) {
  var pathname = getUrlPathName(uri);
  return pathname.indexOf(context) === 0;
}

function matchSingleGlobPath(pattern, uri) {
  var pathname = getUrlPathName(uri);
  var matches = micromatch([pathname], pattern);
  return matches && matches.length > 0;
}

function matchMultiGlobPath(patternList, uri) {
  return matchSingleGlobPath(patternList, uri);
}
/**
 * @param  {String} contextList ['/api', '/ajax']
 * @param  {String} uri     'http://example.org/api/b/c/d.html'
 * @return {Boolean}
 */


function matchMultiPath(contextList, uri) {
  var isMultiPath = false;

  var _iterator = _createForOfIteratorHelper(contextList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var context = _step.value;

      if (matchSingleStringPath(context, uri)) {
        isMultiPath = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return isMultiPath;
}
/**
 * Parses URI and returns RFC 3986 path
 *
 * @param  {String} uri from req.url
 * @return {String}     RFC 3986 path
 */


function getUrlPathName(uri) {
  return uri && url.parse(uri).pathname;
}

function isStringPath(context) {
  return _.isString(context) && !isGlob(context);
}

function isGlobPath(context) {
  return isGlob(context);
}